<mat-form-field appearance="outline" class="no-bottom flex-1">
  <mat-label>{{label()}}</mat-label>
  <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="customerAutoComplete" #customerSearchInput="" class="customer-autocomplete-material-input" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
  <div matSuffix="" class="flex items-center">
    @if (isLoadingCustomers) {
      <mat-spinner diameter="14" class="mx2"></mat-spinner>
    } @else {
      <button type="button" (click)="refreshCustomers(); $event.stopPropagation();" mat-icon-button="" color="primary">
        <mat-icon [ngClass]="{ 'gray': control().disabled }">refresh</mat-icon>
      </button>
    }
  </div>
  <mat-autocomplete autoActiveFirstOption="" #customerAutoComplete="matAutocomplete" [displayWith]="displayWithCustomer" panelWidth="auto">
    @for (customer of customers; track customer) {
      <mat-option [value]="customer">
        @if (customer.type == 'Person') {
          <mat-icon class="icon-small mr1">person_outline</mat-icon>
        }
        @if (customer.type == 'Company') {
          <mat-icon class="icon-small mr1">business_center</mat-icon>
        }
        @if (customer.type == 'Collaboration') {
          <mat-icon class="icon-small mr1">people_outline</mat-icon>
        }
        {{customer.name}} @if (customer.email) {
        <span class="gray">({{customer.email}})</span>
      }
    </mat-option>
  }
  @if (required() === false) {
    <mat-option [value]="null">
      <span translate="">None</span>
    </mat-option>
  }
</mat-autocomplete>
</mat-form-field>